import { IPostUploads, IUploadingFiles } from 'redux-store/api/activity-feed';
import { DOCUMENT_FORMATS } from 'utils/constants';

export const isAudio = (mimeType?: string) => {
  if (mimeType?.includes('audio')) {
    return true;
  }

  return false;
};

export const isFile = (name: string) => {
  return DOCUMENT_FORMATS.includes(name.substring(name.lastIndexOf('.')));
};

export const isVideo = (mimeType?: string) => {
  if (mimeType?.includes('video')) {
    return true;
  }

  return false;
};

export const isVideoOrAudio = (mimeType?: string) => {
  if (isVideo(mimeType) || isAudio(mimeType)) {
    return true;
  }

  return false;
};

export const getImageUrl = (item: IUploadingFiles) => {
  if (isVideoOrAudio(item?.mimeType)) {
    return item?.previewUrl;
  }

  return item?.url;
};

export const isUploadsFromPost = (data: any[]): data is IPostUploads[] => {
  return data?.some((item) => item.mimeType);
};

export const hasMimeType = (data: any): data is IPostUploads => {
  return data?.mimeType;
};

export const getPreviewHeight = (previewUrl: string, containerWidth: number): Promise<number> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      if (!img.naturalWidth || !img.naturalHeight) {
        reject(new Error('Invalid image size'));
        return;
      }
      const aspectRatio = img.naturalHeight / img.naturalWidth;
      resolve(containerWidth * aspectRatio);
    };
    img.onerror = reject;
    img.src = previewUrl;
  });
};
